import React from "react";
import PropTypes from "prop-types";

import { Select } from "../../components/simple";

import { audienceFiltersStyles } from "../../helpers/select/styles/filters";

function Filters({
  filters,
  onChangeFilter,
  countries,
  userProfiles,
  currentSubscription
}) {
  let filtersType = [
    { label: "All", value: "All" },
    { label: "Pre-build", value: "pre-build" },
    { label: "TGI", value: "tgi" }
  ];

  if (currentSubscription !== "Light") {
    filtersType = [...filtersType, { label: "Custom", value: "Custom" }];
  }

  const filtersCountry = [
    { label: "All", value: "All" },
    ...countries
      .map(country => {
        let label = country.name;
        if (country.name === "United Kingdom") {
          label = "UK";
        }

        return {
          label,
          value: country.name
        };
      })
      .filter((item, idx, list) => {
        const beforeValue = list.slice(0, idx);
        return !beforeValue.some(stateItem => stateItem.value === item.value);
      })
  ];

  let filtersCreatedBy = [
    { label: "All", value: "All" }
    // { label: "GDR", value: "GDR" }
  ];

  if (currentSubscription !== "Light") {
    filtersCreatedBy = [
      ...filtersCreatedBy,
      ...userProfiles.map(user => ({
        label: user.name,
        value: user.name
      }))
    ]
      .filter(user => user.label !== "")
      .filter((item, idx, list) => {
        const beforeValue = list.slice(0, idx);
        return !beforeValue.some(stateItem => stateItem.value === item.value);
      });
  }

  return (
    <>
      <Select
        label=""
        containerClass="filter"
        isSearchable={false}
        styles={audienceFiltersStyles}
        value={filters.country}
        placeholder="Country"
        options={filtersCountry}
        name="country"
        handleChange={onChangeFilter}
        autosize
      />
      <Select
        label=""
        containerClass="filter"
        isSearchable={false}
        styles={audienceFiltersStyles}
        value={filters.type}
        placeholder="Type"
        options={filtersType}
        name="type"
        handleChange={onChangeFilter}
      />

      <Select
        label=""
        containerClass="filter"
        isSearchable={false}
        styles={audienceFiltersStyles}
        value={filters.createdBy}
        placeholder="Added By"
        options={filtersCreatedBy}
        name="createdBy"
        handleChange={onChangeFilter}
      />
    </>
  );
}

export default Filters;

Filters.propTypes = {
  currentSubscription: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    type: PropTypes.string,
    country: PropTypes.string,
    createdBy: PropTypes.string
  }).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  userProfiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChangeFilter: PropTypes.func.isRequired
};
